import { memo } from 'react';
import Editor from './Editor.js';

var index = /*#__PURE__*/memo(Editor);

export default index;
